module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "person2.bb3dbac7.png" + "?" + Date.now();